<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Enrol Users &amp; Groups to Playlist
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="slideout-container">
      <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Users</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" v-if="this.e1 == 2" step="2"
            >Select Groups</v-stepper-step
          >
          <v-stepper-step
            :complete="e1 > 2"
            style="text-align: center"
            v-else
            step="2"
            >Click Groups to enrol any groups</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y overflow">
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <div class="filterSection">
              <v-text-field
                v-model="userSearch"
                label="Filter Users By Name Or Email"
                type="text"
                @change="applyUserSearch"
                append-icon="fa-search"
                class="filter-user"
              ></v-text-field>
              <v-select v-if="this.locations.length"
                :items="locations"
                :clearable="true"
                item-text="name"
                item-value="id"
                :placeholder="$globalConfig.APP_NAME === 'senso' ? 'Select Sites' : 'Select Locations'"
                multiple
                small-chips
                class="categories"
                @change="filterUsersByLocations($event)"
                attach
              >
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
            </v-select>
              </div>
              <v-expansion-panels accordion v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Users NOT Enrolled</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="userLoading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="userLoading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table
                      v-model="unAssignedUsers"
                      :headers="computedHeaders"
                      :options.sync="userOptions2"
                      :server-items-length="serverUserItemsLength2"
                      v-show="!userLoading2"
                      :items="users2"
                      item-key="id"
                      show-select
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                      }"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                  >
                    Enrolled Users
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="userLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="userLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table
                      v-model="selectedUsers"
                      :headers="computedHeaders"
                      :options.sync="userOptions"
                      :server-items-length="serverUserItemsLength"
                      v-show="!userLoading"
                      :items="users"
                      item-key="id"
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                      }"
                      @toggle-select-all="selectAllToggle"
                    >
                      <template
                        v-slot:item.data-table-select="{
                          item,
                          isSelected,
                          select,
                        }"
                      >
                        <v-simple-checkbox
                          :value="isSelected"
                          :readonly="item.disabled"
                          :disabled="item.disabled"
                          @input="select($event)"
                          :ripple=false
                        ></v-simple-checkbox>
                      </template>
                      <template v-slot:item.info="{ item }">
                        <v-tooltip v-if="item.disabled" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              class="ml-1"
                              text
                              x-small
                              color="$improve-grey-900"
                              style="width: auto"
                            >
                              <v-icon x-small>fa fa-question</v-icon>
                            </v-btn>
                          </template>
                          <span
                            >This user cannot be moved because it was imported
                            from a group, <br />Please edit the group members
                            instead</span
                          >
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2" class="max-height-list scroll-y overflow">
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-text-field
                v-model="groupSearch"
                label="Filter Groups By Name"
                type="text"
                @change="applyGroupSearch"
                append-icon="fa-search"
                class="filter-user"
              ></v-text-field>
              <v-expansion-panels accordion v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Groups NOT Enrolled</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="groupLoading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="groupLoading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table
                      v-model="selectedGroups2"
                      :headers="groupHeaders"
                      :options.sync="groupOptions2"
                      :server-items-length="serverGroupItemsLength2"
                      v-show="!groupLoading2"
                      :items="groups2"
                      item-key="id"
                      show-select
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15],
                      }"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Groups Enrolled</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="groupLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="groupLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table
                      v-model="selectedGroups"
                      :headers="groupHeaders"
                      :options.sync="groupOptions"
                      :server-items-length="serverGroupItemsLength"
                      v-show="!groupLoading"
                      :items="groups"
                      item-key="id"
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15],
                      }"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute height="auto">
      <v-flex class="pa-4" text-right>
        <div v-if="e1 == 1" class="sm-space-between fit-btn-underscreen">
          <v-btn color="grey300" class=" cancel-button" @click="closePanel"
            >Cancel</v-btn
          >
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn
            v-else
            color="primary"
            class="mr-4 add-course-button"
            :disabled="unAssignedUsers.length < 1"
            @click="assignUsers"
            >Enrol Users</v-btn
          >
          <v-btn
            v-if="!loading"
            color="dark-blue"
            class="add-course-button"
            @click="e1 = 2"
            >Groups</v-btn
          >
        </div>
        <div v-if="e1 == 2">
          <v-btn color="grey300" class="mr-4" @click="e1 = 1" v-if="!loading"
            >Back</v-btn
          >
          <v-btn v-if="loading" loading></v-btn>
          <v-btn
            v-else
            color="primary"
            class="add-course-button"
            @click="assignUsers"
            >Enrol</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import channelAPI from '@/api/channel.js';
import groupAPI from '@/api/group.js';
export default {
  name: 'Enrol',
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: '',
    },
    locations: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      userHeaders: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: '', value: 'info' },
      ],
      groupHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
      ],
      panel: [0, 1],
      panel2: [0, 1],
      loading: false,
      e1: 1,
      selectedUsers: [],
      selectedGroups: [],
      userSearch: '',
      groupSearch: '',
      users: [],
      groups: [],
      userSearchParams: '',
      userUnEnrolledSearchParams: '',
      groupSearchParams: '',
      groupSearchParams2: '',
      userOptions: {},
      groupOptions: {},
      groupOptions2: {},
      userLoading: false,
      groupLoading: false,
      userPagination: {},
      groupPagination: {},
      users2: [],
      userPagination2: {},
      userLoading2: false,
      unAssignedUsers: [],
      userOptions2: {},
      groups2: [],
      groupPagination2: {},
      groupLoading2: false,
      selectedGroups2: [],
      count: 0,
      successMessage: 'Users Successfully Enrolled.',
      errorMessage: 'Oops, something went wrong!',
      allSelectedGroups: [],
      UnEnrollNotification:
        'Unassigning user(s) or group(s) from this course will PERMANENTLY DELETE all their progress and completion data for all users. Are you sure you want to proceed?',
      successUnEnrollMessage:
        'User(s) or Group(s) are now unassigned and all their progress has been deleted. ',
      disabledCount: 0,
      filterLocations: '',
      debounceTimeout: null,
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.userHeaders];
      if (this.locations.length) {
        headers.splice(3, 0, { text: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`, value: 'location', sortable: false });
      }
      return headers;
    },
    serverUserItemsLength: function () {
      return this.userPagination.total;
    },
    userItemsPerPage: function () {
      return this.userPagination.per_page;
    },
    userPage: function () {
      return this.userPagination.current_page;
    },
    userParams: function () {
      return this.$gf.getQueryString(
        this.userOptions,
        this.serverUserItemsLength
      );
    },
    userUnEnrolledParams: function () {
      return this.$gf.getQueryString(
        this.userOptions2,
        this.serverUserItemsLength2
      );
    },
    selectedUsersTotal: function () {
      return this.selectedUsers.length;
    },
    serverGroupItemsLength: function () {
      return this.groupPagination.total;
    },
    groupItemsPerPage: function () {
      return this.groupPagination.per_page;
    },
    groupPage: function () {
      return this.groupPagination.current_page;
    },
    groupParams: function () {
      return this.$gf.getQueryString(this.groupOptions);
    },
    groupParams2: function () {
      return this.$gf.getQueryString(this.groupOptions2);
    },
    selectedGroupsTotal: function () {
      return this.selectedGroups.length;
    },
    serverUserItemsLength2: function () {
      return this.userPagination2.total;
    },
    serverGroupItemsLength2: function () {
      return this.groupPagination2.total;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    userOptions: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true,
    },
    userOptions2: {
      handler() {
        this.getUnenrolledUsers();
      },
      deep: true,
    },
    groupOptions: {
      handler() {
        this.getEnrolledGroups();
      },
      deep: true,
    },
    groupOptions2: {
      handler() {
        this.getUnenrolledGroups();
      },
      deep: true,
    },
  },
  mounted() {
    // this.getSelected();
  },
  methods: {
    /*sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },*/
    /*getUsers() {
      this.userLoading = true;
      userAPI.getClients(this.userParams, this.userSearchParams).then(resp => {
        this.users = resp.data.data;
        this.userPagination = resp.data.meta.pagination;
        this.userLoading = false;
      });
    },*/
    getEnrolledUsers() {
      this.userLoading = true;
      channelAPI
        .getChannelEnrolledUsers(
          this.id,
          this.userParams,
          this.userSearchParams
        )
        .then((resp) => {
          this.users = resp.data.data;
          const self = this;
          this.users.map((item) => {
            if (item.disabled) self.disabledCount += 1;
          });
          this.userPagination = resp.data.meta.pagination;
          this.userLoading = false;
          //this.selectedUsers = resp.data.data;
        });
    },
    getUnenrolledUsers() {
      this.userLoading2 = true;
      channelAPI
        .getChannelUnenrolledUsers(
          this.id,
          this.userUnEnrolledParams,
          this.userUnEnrolledSearchParams
        )
        .then((resp) => {
          this.users2 = resp.data.data;
          this.userPagination2 = resp.data.meta.pagination;
          this.userLoading2 = false;
          this.users2.length == 0
            ? (this.allUsersEnrolled = true)
            : (this.allUsersEnrolled = false);
        });
    },
    getSelected() {
      channelAPI
        .getChannelUser(
          this.id,
          '?include=users,groups,enrolledIndividualUsers'
        )
        .then((resp) => {
          //this.selectedUsers = resp.data.data.enrolledIndividualUsers.data;
          //this.selectedGroups = resp.data.data.groups.data;
          this.allSelectedGroups = resp.data.data.groups.data;

          this.groupLoading = false;
          this.groups = resp.data.data.groups.data;
          //this.groupPagination['pagination']['total'] = resp.data.data.groups.data.length;
        });
    },
    getEnrolledGroups() {
      this.groupLoading = true;
      channelAPI
        .getChannelEnrolledGroupsWithState(
          this.id,
          this.groupParams,
          this.groupSearchParams
        )
        .then((resp) => {
          this.groupLoading = false;
          this.groupPagination = resp.data.meta.pagination;
          var v = this;
          v.groups = resp.data.data;
          this.groupSearchParams = '';
        });
    },
    getUnenrolledGroups() {
      this.groupLoading2 = true;

      channelAPI
        .getChannelUnenrolledGroupsWithState(
          this.id,
          this.groupParams2,
          this.groupSearchParams2
        )
        .then((resp) => {
          this.groupLoading2 = false;
          this.groupPagination2 = resp.data.meta.pagination;
          var v = this;
          v.groups2 = resp.data.data;
          this.groupSearchParams2 = '';
        });
    },
    getGroups() {
      if (this.selectedGroups.length <= 0) {
        this.count++;
        if (this.count < 3) setTimeout(this.getGroups, 1000);
      }
      this.groupLoading2 = true;
      groupAPI
        .getGroups(this.groupParams, this.groupSearchParams)
        .then((resp) => {
          this.groupLoading2 = false;
          let assignedGroups = [];
          this.allSelectedGroups.forEach(function (x) {
            assignedGroups.push(x.id);
          });

          if (assignedGroups.length > 0) {
            this.groups2 = resp.data.data.filter((group) => {
              if (!assignedGroups.includes(group.id)) {
                return group;
              }
            });
          } else {
            this.groups2 = resp.data.data;
          }
          this.groupPagination2 = resp.data.meta.pagination;
        });
    },
    applyUserSearch() {
      this.createSearchParams();
    },
    applyGroupSearch() {
      this.groupSearchParams =
        this.groupParams + '&search=name:' + this.groupSearch;
      this.groupSearchParams2 =
        this.groupParams2 + '&search=name:' + this.groupSearch;
      // this.getGroups();
      this.getEnrolledGroups();
      this.getUnenrolledGroups();
    },
    assignUsers() {
      this.processEnrolUsers();
    },
    processEnrolUsers(toast = '') {
      this.$snotify.remove(toast.id);
      this.loading = true;
      channelAPI
        .assignUsers(this.id, {
          //assign_users: this.processSelectedUsers(),
          unassign_users: this.processUnassignSelectedUsers(),
          //assign_groups: this.processSelectedGroups(),
          unassign_groups:
            this.e1 == 2 ? this.processUnassignSelectedGroups() : [],
        })
        .then(() => {
          EventBus.$emit('CHANNELS_UPDATED', this.params);
          this.closePanel();
          if (
            (this.processSelectedUsers().length > 0 &&
              this.processUnassignSelectedUsers().length > 0) ||
            (this.processSelectedGroups().length > 0 &&
              this.processUnassignSelectedGroups().length > 0)
          ) {
            this.$snotify.success(this.successUnEnrollMessage);
          } else if (
            (this.processSelectedUsers().length > 0 &&
              this.processUnassignSelectedUsers().length <= 0) ||
            (this.processSelectedGroups().length > 0 &&
              this.processUnassignSelectedGroups().length <= 0)
          ) {
            this.$snotify.success(this.successUnEnrollMessage);
          } else if (
            (this.processSelectedUsers().length <= 0 &&
              this.processUnassignSelectedUsers().length >= 0) ||
            (this.processSelectedGroups().length <= 0 &&
              this.processUnassignSelectedGroups().length >= 0)
          ) {
            this.$snotify.success(this.successMessage);
          }
          // else {
          //     this.$snotify.success(this.successMessage);
          // }

          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    processSelectedUsers() {
      let users = [];
      this.selectedUsers.forEach(function (x) {
        users.push(x.id);
      });
      return users;
    },
    processUnassignSelectedUsers() {
      let users = [];
      if (this.unAssignedUsers.length > 0) {
        this.unAssignedUsers.forEach(function (x) {
          users.push(x.id);
        });
      }
      return users;
    },
    processSelectedGroups() {
      let groups = [];
      this.selectedGroups.forEach(function (x) {
        groups.push(x.id);
      });
      return groups;
    },
    processUnassignSelectedGroups() {
      let groups = [];
      this.selectedGroups2.forEach(function (x) {
        groups.push(x.id);
      });
      return groups;
    },
    closePanel() {
      this.$emit('closePanel', {});
    },
    selectAllToggle(props) {
      if (
        props &&
        this.selectedUsers.length != this.users.length - this.disabledCount
      ) {
        this.selectedUsersArray = [...this.users];
        this.selectedUsersArray.forEach((item) => {
          if (!item.disabled) {
            this.selectedUsers.push(item);
          }
        });
      } else {
        this.selectedUsers = [];
      }
    },
    filterUsersByLocations(data){
      clearTimeout(this.debounceTimeout);
      this.filterLocations = data.toString();
      this.debounceTimeout = setTimeout(() => {
        this.createSearchParams();
      }, 1000);
    },
    createSearchParams(){
      this.userSearchParams = '';
      this.userUnEnrolledSearchParams = '';
      this.userOptions.page = 1;
      this.userOptions2.page = 1;
      if(this.userSearch){
      this.userSearchParams = this.userParams + "&search=first_name:" +
            this.userSearch + ";last_name:" + this.userSearch+ ';email:' + this.userSearch;

      this.userUnEnrolledSearchParams = this.userUnEnrolledParams + "&search=first_name:" +
             this.userSearch + ";last_name:" + this.userSearch+ ';email:' + this.userSearch;
      }
      if (this.filterLocations) {
        this.userSearchParams += '&locations=' + this.filterLocations;
        this.userUnEnrolledSearchParams += '&locations=' + this.filterLocations;
      }
      this.getEnrolledUsers();
      this.getUnenrolledUsers();
    }
  },
};
</script>

<style>
.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex: none;
}
.snotify-confirm .snotifyToast__body {
  font-weight: 600 !important;
}
</style>
